<dx-box direction="row">
    <dxi-item [ratio]="2">
        <dx-box direction="row"
            align="left"
            width="100%">
          <dxi-item [baseSize]="50">
            <dx-button icon="chevronleft" [height]="47"
                      (onClick)="prev_Click_from()">
            </dx-button>
          </dxi-item>
          <dxi-item [baseSize]="320">
            <dx-drop-down-box width="auto" fieldTemplate="field" [height]="47">
              <dx-calendar [minZoomLevel]="minZoomLevel" [zoomLevel]="zoomLevel" [firstDayOfWeek]="1"
                          [maxZoomLevel]="maxZoomLevel" (onValueChanged)="fromDateChanged($event)" [max]="maxDate">
              </dx-calendar>
              <div *dxTemplate="let data of 'field'">
                  <dx-text-box [value]="fromText" [readOnly]="true" [height]="47"></dx-text-box>
              </div>
            </dx-drop-down-box>
            <!-- <dx-date-box [(value)]="dateFrom" [showClearButton]="true" displayFormat="dd.MM.yyyy" [height]="47" [max]="maxDate" type="date"></dx-date-box> -->
          </dxi-item>
          <dxi-item [baseSize]="50">
            <dx-button icon="chevronright" [height]="47"
                      (onClick)="next_Click_from()">
            </dx-button>
          </dxi-item>
          <dxi-item [baseSize]="50" style="margin-left: 5px">
            <dx-button icon="chevronleft" [height]="47"
                      (onClick)="prev_Click_to()">
            </dx-button>
          </dxi-item>
          <dxi-item [baseSize]="320">
            <dx-drop-down-box width="auto" fieldTemplate="field" [height]="47">
              <dx-calendar [minZoomLevel]="minZoomLevel" [zoomLevel]="zoomLevel" [firstDayOfWeek]="1"
                          [maxZoomLevel]="maxZoomLevel" (onValueChanged)="toDateChanged($event)" [max]="maxDate">
              </dx-calendar>
              <div *dxTemplate="let data of 'field'">
                  <dx-text-box [value]="toText" [readOnly]="true" [height]="47"></dx-text-box>
              </div>
            </dx-drop-down-box>
            <!-- <dx-date-box  [(value)]="dateTo" [showClearButton]="true" [(min)]="dateFrom" displayFormat="dd.MM.yyyy" [height]="47" [max]="maxDate" type="date"></dx-date-box> -->
          </dxi-item>
          <dxi-item [baseSize]="50">
            <dx-button icon="chevronright" [height]="47"
                      (onClick)="next_Click_to()">
            </dx-button>
          </dxi-item>
          <dxi-item *ngIf="showSearchButton" [baseSize]="100" style="margin-left: 20px">
            <dx-button [text]="searchText" [height]="47"
                      (onClick)="search_Click()">
            </dx-button>
          </dxi-item>
        </dx-box>
    </dxi-item>
</dx-box>
